
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.244 4.41a.833.833 0 011.179 0l5 5a.834.834 0 010 1.179l-5 5a.834.834 0 01-1.179-1.179l3.578-3.577H4.167a.833.833 0 010-1.667h9.655l-3.578-3.577a.833.833 0 010-1.179z","fill":"#008C89"}})])
          )
        }
      }
    